import React from 'react';
import { Box, Typography } from '@availity/element';
import { useNavigate } from 'react-router-dom';
import Button from '../../Utils/components/Button';
import Animation from '../../Utils/components/Animation';
import divider from '../../../static/assets/icons/Divider-4.svg';

const MCPSection = () => {
  const navigate = useNavigate();
  
  const handleViewDocs = () => {
    navigate('/docs/mcp');
  };
  
  return (
  <Box
    sx={{
      width: 1,
      pt: { xs: 8, md: 16.5 },
      pb: 0,
      background: '#000C30',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: { xs: 6, md: 11 },
    }}
  >
    <Box
      sx={{
        width: { xs: 1, lg: 976 },
        maxWidth: 976,
        px: { xs: 2, lg: 0 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <Box
        sx={{
          width: 49,
          height: 25,
          px: 1.5,
          py: 1,
          background: '#BF4D17',
          borderRadius: 100,  
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',  
        }}
      >
        <Typography
          sx={{
            color: 'white',
            fontSize: { xs: 12, md: 14 },
            fontFamily: 'Lato',
            fontWeight: 700,
          }}
        >
          New
        </Typography>
      </Box>
      <Typography
        sx={{
          textAlign: 'center',
          color: 'white',
          fontSize: { xs: 28, md: 36 },
          fontFamily: 'Montserrat',
          fontWeight: 600,
          lineHeight: 48/36,
        }}
      >
        Introducing Availity MCP for Agents
      </Typography>
    </Box>

    <Box
      sx={{
        width: { xs: 'calc(100% - 32px)', lg: 1200 },
        maxWidth: 1200,
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
        gap: 0,
        background: 'linear-gradient(180deg, #000C30 0%, #001041 100%)',
        borderRadius: 3,
        border: '1px solid #0F2A7C',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          flex: 1.3,
          p: { xs: 3, md: 6 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: { xs: 'center', lg: 'flex-start' },
          textAlign: { xs: 'center', lg: 'left' },
          gap: { xs: 3, md: 4 },
        }}
      >
        <Typography
          sx={{
            color: 'white',
            fontSize: { xs: 28, md: 28 },
            fontFamily: 'Montserrat',
            fontWeight: 600,
            lineHeight: 40/28,
          }}
        >
          Empower your agents with<br />
          next-generation connectivity
        </Typography>
        <Box component="img" src={divider} alt="" sx={{ width: 'fit-content' }} />
        <Typography
          sx={{
            color: '#FFFFFF',
            fontSize: { xs: 18, md: 18 },
            fontFamily: 'Lato',
            fontWeight: 400,
            lineHeight: 26/18,
          }}
        >
          Availity&apos;s Model Context Protocol (MCP) Server delivers a secure, streamlined way to manage healthcare transactions. Built for speed and compliance, MCP simplifies eligibility checks, claims submissions, and prior authorizations, reducing administrative burden and improving accuracy. With real-time data exchange and intuitive API integrations, agents can work smarter, serve customers faster, and stay ahead in a rapidly evolving healthcare landscape.
        </Typography>
        <Box sx={{ width: { xs: 1, lg: 'fit-content' } }}>
            <Button variant="navbar-signup"
              sx={{
                width: 'fit-content'
              }}
              onClick={handleViewDocs}
            >
              View MCP Overview
            </Button>
          </Box>
      </Box>

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderLeft: { xs: 'none', lg: '1px solid #0F2A7C' },
        }}
      >
        <Animation
          src="/static/assets/illustrations/Animation _ MCP.html"
          sx={{ width: '100%', aspectRatio: '477 / 518' }}
        />
      </Box>
    </Box>
  </Box>
  );
};

export default MCPSection;
